query TravelPolicyExpenditureTypes {
  travelPolicyExpenditureTypes(orderBy: EXPENDITURE_TYPE_ASC) {
    nodes {
      id
      expenditureType
      _isMilesAllowed
      _isCountry1Allowed
      _isCountry2Allowed
      _isStateReference1Allowed
      _isStateReference2Allowed
      allowanceHint
    }
  }
}
